<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>音视频课程管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/cardMp3List')">每日打卡音频</a>
        </el-breadcrumb-item>

      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul v-show="backS == 1" class="cont_btns">
        <li>
          <el-button @click="jumpTo('/userCardScoreList')"  type="primary">返回</el-button>
        </li>
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='代理信息'>
            <el-input
              style="width:200px"
              v-model="filters.keywords"
              placeholder="请输入代理信息搜索"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="finishTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="filters.finishTime"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

          </el-form-item>



        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="代理手机号"
          >
          </el-table-column>

          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;height:50px"
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="level_num"
            label="代理等级"
          >
          </el-table-column>

          <el-table-column
            prop="one_work"
            label="跟读音频"
            width="350px"
          >
          <template slot-scope="scope">
              <audio style="width:320px" v-if="scope.row.oneWork != null" :src="scope.row.oneWork.url" controls="controls">
                浏览器不支持
              </audio>
            </template>
          </el-table-column>

          <el-table-column
            prop="two_work"
            label="分享音频"
            width="350px"
          >
            <template slot-scope="scope">
              <audio style="width:320px" v-if="scope.row.twoWork != null" :src="scope.row.twoWork.url" controls="controls">
                浏览器不支持
              </audio>
            </template>
          </el-table-column>

          <el-table-column
            prop="title"
            label="跟读文章"
          >
          </el-table-column>

          <el-table-column
            prop="create_time1"
            label="上传时间"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "judgeList",
  created() {
    if (this.$route.query.userId != null)
    {
      this.userId = this.$route.query.userId;
      this.backS = 1;
    }
  },
  data() {
    return {
      picList:[],
      userId:null,
      dialogAddVisible:false,
      filters: {
        finishTime:null,
        keywords: null
      },
      page_num: 1,
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null,
      backS:2
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
     addPostDialog() {
      this.$router.push({
        path: "/addCourse"
      });
    },
    editPostDialog(row) {
      this.$router.push({
        path: "/addCourse",
        query: {
          good: row
        }
      });
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        userId:that.userId,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.keywords) {
        params.keywords = that.filters.keywords;
      }
      if (that.filters.finishTime) {
        params.finishTime = that.filters.finishTime.getTime();
      }
      that.loading = true;
      API.finish_work_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].oneWork = JSON.parse(result.result.list[i].one_work);
                  if (result.result.list[i].two_work == null || result.result.list[i].two_work == '')
                  {
                    result.result.list[i].twoWork = null;
                  } else {
                    result.result.list[i].twoWork = JSON.parse(result.result.list[i].two_work);
                  }
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          console.error(error)
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.shop-pic{
    width: 100%;
    /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
    height: 80vh;
    overflow: hidden;
    overflow-y: auto;
}
.shop-pic img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/cardMp3List.vue